import React, { FunctionComponent } from "react"
import Grid from "../../components/Grid/Grid"
import LinkItem from "../../components/Grid/LinkItem"
import Loader from "../../components/Loader/Loader"
import Pagination from "../../components/Pagination/Pagination"
import Seo from "../../components/Seo/Seo"
import { iAsset, iAssetQuery } from "../../definitions/Assets"
import { useData } from "../../hooks/useData"
import AssetFilters from "./Filters"
import AssetItem from "./Item"

const Assets: FunctionComponent = () => {
  const { total, data, loading, setQuery, query } = useData<
    iAssetQuery,
    iAsset
  >({
    link: "/v2/assets",
    defaultQuery: {},
    shouldPushQuery: true,
  })

  return (
    <>
      <Seo title="Assets" />
      <div className="content">
        <div className="content-header">
          <h1>Assets ({total})</h1>
          <AssetFilters setQuery={setQuery} query={query} />
        </div>
        <div className="grid-wrap">
          {loading ? (
            <Loader />
          ) : data.length ? (
            <Grid>
              {data.map((asset) => (
                <LinkItem key={asset._id} url={"/assets/" + asset.url}>
                  <AssetItem {...asset} />
                </LinkItem>
              ))}
            </Grid>
          ) : (
            <div className="no-data">No matching results.</div>
          )}
        </div>
        <Pagination total={total} setQuery={setQuery} limit={50} />
      </div>
    </>
  )
}

export default Assets
